<template>
    <!-- <select id="dashboard" v-on:change="changeLink">
        <option v-for="option in dashboards" :key="option" v-bind:value="option">{{option}}</option>
    </select> -->
    <otif-select 
                class="OTDashboardSelect" :values="dashboards" :multiple="false" v-model="selectedFacets" :searchable="false"
                placeholder="Choose a dashboard">
    </otif-select>
</template>

<script>

import axios from 'axios';

export default {

    props: ['selectedFacet'],

    data () {
        return {
            sf: 'Activity Dashboard',
            dashboards: ["Activity Dashboard","Event Dashboard"]
        }
    },

    methods: {

    },

    computed: {

        selectedFacets: {
            // getter
            get: function () {
                return this.selectedFacet;
            },
            // setter
            set: function (newValue) {
                this.sf = newValue;
                if(this.sf == "Activity Dashboard"){
                    this.$store.state.facets.selectedFacets = {}
                    this.$router.push({path: '/dashboard' })
                }
                else if (this.sf == "Event Dashboard"){
                    this.$store.state.facets.selectedFacets = {}
                    this.$router.push({name: 'events' , params: {isRoute:'false'}})
                }
            }
        }
    }
}

</script>
